import { createSlice } from "@reduxjs/toolkit"
import { IRevPennyDropRes, IBankDetailsSlice, IRevPennyDropStatusRes } from "."

const initialState: IBankDetailsSlice = {
  revPennyDrop: {
    loading: false,
    isError: false,
    errMessage: "",
    data: {} as IRevPennyDropRes,
    status: null,
  },
  revPennyDropStatus: {
    loading: false,
    isError: false,
    errMessage: "",
    data: {} as IRevPennyDropStatusRes,
    status: null,
  },

}

export const bankDetailsSlice = createSlice({
  name: "bankDetails",
  initialState,
  reducers: {
    // Request Reverse Penny Drop
    requestRevPennyDrop: (state) => {
      state.revPennyDrop.loading = true
      state.revPennyDrop.status = null
      state.revPennyDrop.isError = false
    },
    requestRevPennyDropSuccess: (state, action) => {
      state.revPennyDrop.loading = false
      state.revPennyDrop.isError = false
      state.revPennyDrop.data = action.payload.data
      state.revPennyDrop.status = action.payload.status
    },
    requestRevPennyDropFailure: (state, action) => {
      state.revPennyDrop.loading = false
      state.revPennyDrop.isError = true
      state.revPennyDrop.status = action.payload.status
      state.revPennyDrop.errMessage = action.payload.error
    },
    // Get Reverse Penny Drop Status
    getRevPennyDropStatus: (state) => {
      state.revPennyDropStatus.loading = true
      state.revPennyDropStatus.status = null
      state.revPennyDropStatus.isError = false
    },
    getRevPennyDropSuccess: (state, action) => {
      state.revPennyDropStatus.loading = false
      state.revPennyDropStatus.isError = false
      state.revPennyDropStatus.data = action.payload.data
      state.revPennyDropStatus.status = action.payload.status
    },
    getRevPennyDropFailure: (state, action) => {
      state.revPennyDropStatus.loading = false
      state.revPennyDropStatus.isError = true
      state.revPennyDropStatus.data = action.payload.data
      state.revPennyDropStatus.status = action.payload.status
      state.revPennyDropStatus.errMessage = action.payload.error
    },
    // resetTradesSlice: () => initialState,
  },
})

// Action
export const {
  requestRevPennyDrop,
  requestRevPennyDropSuccess,
  requestRevPennyDropFailure,
  getRevPennyDropStatus,
  getRevPennyDropSuccess,
  getRevPennyDropFailure,
} = bankDetailsSlice.actions

export default bankDetailsSlice.reducer
